var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** `${tag}${code before}${code after}` → the mark the first subfield must end with. */
var RULES = {
    '110ab': '.',
    '110bb': '.',
    '410ab': '.',
    '410bb': '.',
};
/** The title of a name/title heading; the name before it ends in a period. */
var TITLE_CODE = 't';
/** Already ends a sentence; ISBD does not add a period after these. */
var TERMINAL = /[.?!]$/;
/**
 * Codes on `tag` whose arrival can call for a mark on the subfield before them —
 * the subfields whose loaded values the form has to remember.
 */
export var punctuationTriggers = function (tag) { return new Set(Object.keys(RULES).filter(function (key) { return key.slice(0, 3) === tag; }).map(function (key) { return key.slice(4); })); };
/** Every code on `tag` that a rule names on either side — the chain the rules walk. */
var chainCodes = function (tag) { return new Set(Object.keys(RULES).filter(function (key) { return key.slice(0, 3) === tag; }).flatMap(function (key) { return [key[3], key[4]]; })); };
/** `a.v.`, `D.C.`: the final period belongs to the abbreviation, not to the pair. */
var DOTTED_ABBREVIATION = /[^\s.]\.[^\s.]{1,3}\.$/;
/**
 * `rows` — one field instance, in its final subfield order — with the marks
 * the chain calls for, given `changed`: each subfield code whose list differs
 * from what was loaded, with its loaded values.
 *
 * <p>A subfield followed in the chain by a changed code gets the mark, unless
 * it already ends a sentence. The subfield that now ends the chain loses the
 * mark when it was loaded with a changed code after it, i.e. when the
 * cataloguer removed what followed it.
 */
export var punctuateBefore = function (tag, rows, changed) {
    var _a, _b;
    var chain = chainCodes(tag);
    var out = rows.slice();
    var previous = -1;
    out.forEach(function (row, i) {
        var _a, _b, _c;
        var code = (_a = row.subfield_code) !== null && _a !== void 0 ? _a : '';
        if (!chain.has(code))
            return;
        var before = out[previous];
        if (before && changed.has(code)) {
            var mark = RULES["".concat(tag).concat((_b = before.subfield_code) !== null && _b !== void 0 ? _b : '').concat(code)];
            var value = ((_c = before.value) !== null && _c !== void 0 ? _c : '').trimEnd();
            if (mark && value && !TERMINAL.test(value))
                out[previous] = __assign(__assign({}, before), { value: "".concat(value).concat(mark) });
        }
        previous = i;
    });
    var last = out[previous];
    var titled = out.slice(previous + 1).some(function (row) { return row.subfield_code === TITLE_CODE; });
    if (last && !titled) {
        var code_1 = (_a = last.subfield_code) !== null && _a !== void 0 ? _a : '';
        var value_1 = ((_b = last.value) !== null && _b !== void 0 ? _b : '').trimEnd();
        changed.forEach(function (loaded, next) {
            var _a;
            var mark = RULES["".concat(tag).concat(code_1).concat(next)];
            if (!mark || !value_1.endsWith(mark) || DOTTED_ABBREVIATION.test(value_1))
                return;
            // A name typed as `Acme Inc.`: the mark is the component's own, not the pair's.
            if (((_a = last.components) !== null && _a !== void 0 ? _a : []).some(function (c) { return c.value.endsWith(mark) && value_1.endsWith(c.value); }))
                return;
            // Loaded with a `next` after it: a `$a` when any were loaded, a value of
            // the list itself when it was loaded anywhere but in the last place.
            var at = loaded.lastIndexOf(value_1);
            var wasFollowed = code_1 === next ? at >= 0 && at < loaded.length - 1 : loaded.length > 0;
            if (wasFollowed)
                out[previous] = __assign(__assign({}, last), { value: value_1.slice(0, -mark.length) });
        });
    }
    return out;
};
